<template>
    <div class="drag-wrap">
        <div class="drag-tip" v-show="isShowTip">
            <img :src="imageSrc" alt="VLink" draggable="false" />
            <span>{{ noDataTip }}</span>
        </div>
        <span class="tip-btn" v-show="isShowDrag">{{ dragTip }}</span>
        <div class="drag-active-bg" v-show="isShowDrag" @drop.prevent="dropHandle"></div>
    </div>
</template>

<script>
import MultImportPictureModel from "./MultImportPictureModel";
import i18n from "@/i18n";

export default {
    name: "DragUploadPanel",
    props: ["isShowDrag", "isShowTip", "tagId"],
    data() {
        return {
            imageSrc: this.zhiji.staticPath() + "xiaoyue-pic.png",
            imageData: [],
            imageNames: [],
            ifHaveBigPic: false
        };
    },
    computed: {
        noDataTip() {
            return this.$t("zhiji.materialLibrary.dropPicTip");
        },
        dragTip() {
            return this.$t("zhiji.materialLibrary.dragPicTip");
        }
    },
    methods: {
        dropHandle(event) {
            let imageFile = event.dataTransfer.files;
            let formData = new FormData();
            for (let i = 0; i < imageFile.length; i++) {
                if (imageFile[i].size < 1024 * 1024 * 1) {
                    this.imageNames.push(imageFile[i].name);
                    formData.append("images[]", imageFile[i]);
                }
                if (imageFile[i].size > 1024 * 1024 * 1) {
                    this.ifHaveBigPic = true;
                }
            }

            if (this.ifHaveBigPic && this.imageNames.length > 0) {
                this.$message({
                    message: i18n.t("zhiji.materialLibrary.filterExceedPics"),
                    type: 'warning'
                });
            }

            if (this.imageNames.length === 0) {
                this.$message({
                    message: i18n.t("zhiji.materialLibrary.maxPicSize"),
                    type: 'warning'
                });
                return
            }
            imageFile.length > 0 && this.mulitAddClick(this.imageData, formData);
            this.imageNames = [];
            this.ifHaveBigPic = false;
        },
        mulitAddClick(images, formData) {
            this.$store.dispatch("zhiji/showModal", {
                type: MultImportPictureModel,
                data: {
                    type: "add",
                    imgData: images,
                    formData: formData,
                    tagIds: this.tagId ? this.tagId.toString() : '',
                }
            });
            this.$emit("dropClick");
        },
        showErrorModal(errMessage) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: errMessage,
                    colseHandle: () => {
                        this.$emit("dropClick");
                    }
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.drag-wrap {
    .tip-btn {
        display: block;
        width: 280px;
        background-color: #2088f3;
        font-size: 14px;
        color: #fff;
        text-align: center;
        padding: 10px 0;
        position: absolute;
        bottom: 50px;
        left: calc(50% - 140px);
        border-radius: 3px;
        z-index: 101;
    }
    .drag-tip {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        & > img {
            min-width: 150px;
            min-height: 80px;
        }

        & > span {
            width: 200px;
            padding: 15px 0;
            font-size: 12px;
            color: #9b9ba3;
            word-break: break-all;
            text-align: center;
            line-height: 1.3;
        }
    }
    .drag-active-bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 99;
        border: 2px solid #2088f3;
        background-color: rgba(32, 136, 243, 0.2);
    }
}
</style>
